import React from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import BusinessListLayout from "../layouts/Employee/BusinessListLayout";

const BusinessList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <BusinessListLayout />
    </>
  );
};

export default BusinessList;
